import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app/Store";
import { LoadingState } from "../app/LoadingState";
import { beginRequest, completeRequest, rejectRequest, RequestState } from "../app/store/RequestState";
import { getReportCategoriesAsync } from "./ReportsApi";
import { ReportCategoryOption } from "./models/ReportCategoryOption";
interface ReportsEntry extends RequestState {
  data?: ReportCategoryOption[];
}
const initialState: Record<string, ReportsEntry> = {};
export const fetchReportCategories = createAsyncThunk(
  "reports/categories/fetch",
  (siteId: string, { signal }) => getReportCategoriesAsync(siteId, signal),
  {
    condition: (siteId, { getState }) =>
      Boolean(siteId) &&
      (getState() as RootState).reports[siteId]?.loadingState !== LoadingState.Pending,
  }
);
const slice = createSlice({
  name: "reports",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchReportCategories.pending, (state, action) => {
        beginRequest(
          (state[action.meta.arg] ??= { loadingState: LoadingState.None }),
          action.meta.requestId
        );
      })
      .addCase(fetchReportCategories.fulfilled, (state, action) => {
        const entry = state[action.meta.arg];
        if (entry && completeRequest(entry, action.meta.requestId)) {
          entry.data = action.payload;
        }
      })
      .addCase(fetchReportCategories.rejected, (state, action) => {
        const entry = state[action.meta.arg];
        if (entry) {
          rejectRequest(entry, action);
        }
      }),
});
export const reportsReducer = slice.reducer;
